var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HgCruiseSearch',{attrs:{"allowHotjarRecord":"","is-mobile":_vm.isMobile,"is-loading-destinations":_vm.isLoading,"cruiseLines":_vm.cruiseLines,"search-url":_vm.searchUrl,"lang":_vm.lang,"regions":_vm.regions},on:{"onUpdateSearchParameters":_vm.updateSearchParameters,"onTriggerSearch":_vm.triggerSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }